!(function (e, a) {
  'object' == typeof exports && 'undefined' != typeof module
    ? (module.exports = a())
    : 'function' == typeof define && define.amd
      ? define(a)
      : ((e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}), (e.ReactIntlLocaleData.es = a()));
})(this, function () {
  'use strict';
  return [
    {
      locale: 'es',
      pluralRuleFunction: function (e, a) {
        return a ? 'other' : 1 == e ? 'one' : 'other';
      },
      fields: {
        year: {
          displayName: 'año',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} año', other: 'dentro de {0} años' },
            past: { one: 'hace {0} año', other: 'hace {0} años' }
          }
        },
        'year-short': {
          displayName: 'a',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} a', other: 'dentro de {0} a' },
            past: { one: 'hace {0} a', other: 'hace {0} a' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} mes', other: 'dentro de {0} meses' },
            past: { one: 'hace {0} mes', other: 'hace {0} meses' }
          }
        },
        'month-short': {
          displayName: 'm',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} m', other: 'dentro de {0} m' },
            past: { one: 'hace {0} m', other: 'hace {0} m' }
          }
        },
        day: {
          displayName: 'día',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        'day-short': {
          displayName: 'd',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} hora', other: 'dentro de {0} horas' },
            past: { one: 'hace {0} hora', other: 'hace {0} horas' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} h', other: 'dentro de {0} h' },
            past: { one: 'hace {0} h', other: 'hace {0} h' }
          }
        },
        minute: {
          displayName: 'minuto',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} minuto', other: 'dentro de {0} minutos' },
            past: { one: 'hace {0} minuto', other: 'hace {0} minutos' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} min', other: 'dentro de {0} min' },
            past: { one: 'hace {0} min', other: 'hace {0} min' }
          }
        },
        second: {
          displayName: 'segundo',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} segundo', other: 'dentro de {0} segundos' },
            past: { one: 'hace {0} segundo', other: 'hace {0} segundos' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} s', other: 'dentro de {0} s' },
            past: { one: 'hace {0} s', other: 'hace {0} s' }
          }
        }
      }
    },
    { locale: 'es-419', parentLocale: 'es' },
    {
      locale: 'es-AR',
      parentLocale: 'es-419',
      fields: {
        year: {
          displayName: 'año',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} año', other: 'dentro de {0} años' },
            past: { one: 'hace {0} año', other: 'hace {0} años' }
          }
        },
        'year-short': {
          displayName: 'a',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} a', other: 'dentro de {0} a' },
            past: { one: 'hace {0} a', other: 'hace {0} a' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} mes', other: 'dentro de {0} meses' },
            past: { one: 'hace {0} mes', other: 'hace {0} meses' }
          }
        },
        'month-short': {
          displayName: 'm',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} m', other: 'dentro de {0} m' },
            past: { one: 'hace {0} m', other: 'hace {0} m' }
          }
        },
        day: {
          displayName: 'día',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        'day-short': {
          displayName: 'd',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} días', other: 'dentro de {0} días' },
            past: { one: 'hace {0} días', other: 'hace {0} días' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} hora', other: 'dentro de {0} horas' },
            past: { one: 'hace {0} hora', other: 'hace {0} horas' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} h', other: 'dentro de {0} h' },
            past: { one: 'hace {0} h', other: 'hace {0} h' }
          }
        },
        minute: {
          displayName: 'minuto',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} minuto', other: 'dentro de {0} minutos' },
            past: { one: 'hace {0} minuto', other: 'hace {0} minutos' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} min', other: 'dentro de {0} min' },
            past: { one: 'hace {0} min', other: 'hace {0} min' }
          }
        },
        second: {
          displayName: 'segundo',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} segundo', other: 'dentro de {0} segundos' },
            past: { one: 'hace {0} segundo', other: 'hace {0} segundos' }
          }
        },
        'second-short': {
          displayName: 'seg.',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} seg.', other: 'dentro de {0} seg.' },
            past: { one: 'hace {0} seg.', other: 'hace {0} seg.' }
          }
        }
      }
    },
    { locale: 'es-BO', parentLocale: 'es-419' },
    { locale: 'es-BR', parentLocale: 'es-419' },
    { locale: 'es-BZ', parentLocale: 'es-419' },
    { locale: 'es-CL', parentLocale: 'es-419' },
    { locale: 'es-CO', parentLocale: 'es-419' },
    { locale: 'es-CR', parentLocale: 'es-419' },
    { locale: 'es-CU', parentLocale: 'es-419' },
    {
      locale: 'es-DO',
      parentLocale: 'es-419',
      fields: {
        year: {
          displayName: 'Año',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} año', other: 'dentro de {0} años' },
            past: { one: 'hace {0} año', other: 'hace {0} años' }
          }
        },
        'year-short': {
          displayName: 'a',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} a', other: 'dentro de {0} a' },
            past: { one: 'hace {0} a', other: 'hace {0} a' }
          }
        },
        month: {
          displayName: 'Mes',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} mes', other: 'dentro de {0} meses' },
            past: { one: 'hace {0} mes', other: 'hace {0} meses' }
          }
        },
        'month-short': {
          displayName: 'm',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} m', other: 'dentro de {0} m' },
            past: { one: 'hace {0} m', other: 'hace {0} m' }
          }
        },
        day: {
          displayName: 'Día',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        'day-short': {
          displayName: 'd',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} hora', other: 'dentro de {0} horas' },
            past: { one: 'hace {0} hora', other: 'hace {0} horas' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} h', other: 'dentro de {0} h' },
            past: { one: 'hace {0} h', other: 'hace {0} h' }
          }
        },
        minute: {
          displayName: 'Minuto',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} minuto', other: 'dentro de {0} minutos' },
            past: { one: 'hace {0} minuto', other: 'hace {0} minutos' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} min', other: 'dentro de {0} min' },
            past: { one: 'hace {0} min', other: 'hace {0} min' }
          }
        },
        second: {
          displayName: 'Segundo',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} segundo', other: 'dentro de {0} segundos' },
            past: { one: 'hace {0} segundo', other: 'hace {0} segundos' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} s', other: 'dentro de {0} s' },
            past: { one: 'hace {0} s', other: 'hace {0} s' }
          }
        }
      }
    },
    { locale: 'es-EA', parentLocale: 'es' },
    { locale: 'es-EC', parentLocale: 'es-419' },
    { locale: 'es-GQ', parentLocale: 'es' },
    { locale: 'es-GT', parentLocale: 'es-419' },
    { locale: 'es-HN', parentLocale: 'es-419' },
    { locale: 'es-IC', parentLocale: 'es' },
    {
      locale: 'es-MX',
      parentLocale: 'es-419',
      fields: {
        year: {
          displayName: 'año',
          relative: { 0: 'este año', 1: 'el año próximo', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} año', other: 'dentro de {0} años' },
            past: { one: 'hace {0} año', other: 'hace {0} años' }
          }
        },
        'year-short': {
          displayName: 'a',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'en {0} a', other: 'en {0} a' },
            past: { one: 'hace {0} a', other: 'hace {0} a' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'este mes', 1: 'el mes próximo', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'en {0} mes', other: 'en {0} meses' },
            past: { one: 'hace {0} mes', other: 'hace {0} meses' }
          }
        },
        'month-short': {
          displayName: 'm',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'en {0} m', other: 'en {0} m' },
            past: { one: 'hace {0} m', other: 'hace {0} m' }
          }
        },
        day: {
          displayName: 'día',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        'day-short': {
          displayName: 'd',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'en {0} día', other: 'en {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} hora', other: 'dentro de {0} horas' },
            past: { one: 'hace {0} hora', other: 'hace {0} horas' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'en {0} h', other: 'en {0} n' },
            past: { one: 'hace {0} h', other: 'hace {0} h' }
          }
        },
        minute: {
          displayName: 'minuto',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} minuto', other: 'dentro de {0} minutos' },
            past: { one: 'hace {0} minuto', other: 'hace {0} minutos' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'en {0} min', other: 'en {0} min' },
            past: { one: 'hace {0} min', other: 'hace {0} min' }
          }
        },
        second: {
          displayName: 'segundo',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} segundo', other: 'dentro de {0} segundos' },
            past: { one: 'hace {0} segundo', other: 'hace {0} segundos' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'en {0} s', other: 'en {0} s' },
            past: { one: 'hace {0} s', other: 'hace {0} s' }
          }
        }
      }
    },
    { locale: 'es-NI', parentLocale: 'es-419' },
    { locale: 'es-PA', parentLocale: 'es-419' },
    { locale: 'es-PE', parentLocale: 'es-419' },
    { locale: 'es-PH', parentLocale: 'es' },
    { locale: 'es-PR', parentLocale: 'es-419' },
    {
      locale: 'es-PY',
      parentLocale: 'es-419',
      fields: {
        year: {
          displayName: 'año',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} año', other: 'dentro de {0} años' },
            past: { one: 'hace {0} año', other: 'hace {0} años' }
          }
        },
        'year-short': {
          displayName: 'a',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} a', other: 'dentro de {0} a' },
            past: { one: 'hace {0} a', other: 'hace {0} a' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} mes', other: 'dentro de {0} meses' },
            past: { one: 'hace {0} mes', other: 'hace {0} meses' }
          }
        },
        'month-short': {
          displayName: 'm',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} m', other: 'dentro de {0} m' },
            past: { one: 'hace {0} m', other: 'hace {0} m' }
          }
        },
        day: {
          displayName: 'día',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        'day-short': {
          displayName: 'd',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} hora', other: 'dentro de {0} horas' },
            past: { one: 'hace {0} hora', other: 'hace {0} horas' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} h', other: 'dentro de {0} h' },
            past: { one: 'hace {0} h', other: 'hace {0} h' }
          }
        },
        minute: {
          displayName: 'minuto',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} minuto', other: 'dentro de {0} minutos' },
            past: { one: 'hace {0} minuto', other: 'hace {0} minutos' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} min', other: 'dentro de {0} min' },
            past: { one: 'hace {0} min', other: 'hace {0} min' }
          }
        },
        second: {
          displayName: 'segundo',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} segundo', other: 'dentro de {0} segundos' },
            past: { one: 'hace {0} segundo', other: 'hace {0} segundos' }
          }
        },
        'second-short': {
          displayName: 'seg.',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} seg.', other: 'dentro de {0} seg.' },
            past: { one: 'hace {0} seg.', other: 'hace {0} seg.' }
          }
        }
      }
    },
    {
      locale: 'es-SV',
      parentLocale: 'es-419',
      fields: {
        year: {
          displayName: 'año',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} año', other: 'dentro de {0} años' },
            past: { one: 'hace {0} año', other: 'hace {0} años' }
          }
        },
        'year-short': {
          displayName: 'a',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} a', other: 'dentro de {0} a' },
            past: { one: 'hace {0} a', other: 'hace {0} a' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} mes', other: 'dentro de {0} meses' },
            past: { one: 'hace {0} mes', other: 'hace {0} meses' }
          }
        },
        'month-short': {
          displayName: 'm',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} m', other: 'dentro de {0} m' },
            past: { one: 'hace {0} m', other: 'hace {0} m' }
          }
        },
        day: {
          displayName: 'día',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'antier', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        'day-short': {
          displayName: 'd',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} hora', other: 'dentro de {0} horas' },
            past: { one: 'hace {0} hora', other: 'hace {0} horas' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} h', other: 'dentro de {0} h' },
            past: { one: 'hace {0} h', other: 'hace {0} h' }
          }
        },
        minute: {
          displayName: 'minuto',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} minuto', other: 'dentro de {0} minutos' },
            past: { one: 'hace {0} minuto', other: 'hace {0} minutos' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} min', other: 'dentro de {0} min' },
            past: { one: 'hace {0} min', other: 'hace {0} min' }
          }
        },
        second: {
          displayName: 'segundo',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} segundo', other: 'dentro de {0} segundos' },
            past: { one: 'hace {0} segundo', other: 'hace {0} segundos' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} s', other: 'dentro de {0} s' },
            past: { one: 'hace {0} s', other: 'hace {0} s' }
          }
        }
      }
    },
    {
      locale: 'es-US',
      parentLocale: 'es-419',
      fields: {
        year: {
          displayName: 'año',
          relative: { 0: 'este año', 1: 'el año próximo', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} año', other: 'dentro de {0} años' },
            past: { one: 'hace {0} año', other: 'hace {0} años' }
          }
        },
        'year-short': {
          displayName: 'a',
          relative: { 0: 'este año', 1: 'el próximo año', '-1': 'el año pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} a', other: 'dentro de {0} a' },
            past: { one: 'hace {0} a', other: 'hace {0} a' }
          }
        },
        month: {
          displayName: 'mes',
          relative: { 0: 'este mes', 1: 'el mes próximo', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} mes', other: 'dentro de {0} meses' },
            past: { one: 'hace {0} mes', other: 'hace {0} meses' }
          }
        },
        'month-short': {
          displayName: 'm',
          relative: { 0: 'este mes', 1: 'el próximo mes', '-1': 'el mes pasado' },
          relativeTime: {
            future: { one: 'dentro de {0} m', other: 'dentro de {0} m' },
            past: { one: 'hace {0} m', other: 'hace {0} m' }
          }
        },
        day: {
          displayName: 'día',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        'day-short': {
          displayName: 'd',
          relative: { 0: 'hoy', 1: 'mañana', 2: 'pasado mañana', '-2': 'anteayer', '-1': 'ayer' },
          relativeTime: {
            future: { one: 'dentro de {0} día', other: 'dentro de {0} días' },
            past: { one: 'hace {0} día', other: 'hace {0} días' }
          }
        },
        hour: {
          displayName: 'hora',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} hora', other: 'dentro de {0} horas' },
            past: { one: 'hace {0} hora', other: 'hace {0} horas' }
          }
        },
        'hour-short': {
          displayName: 'h',
          relative: { 0: 'esta hora' },
          relativeTime: {
            future: { one: 'dentro de {0} h', other: 'dentro de {0} h' },
            past: { one: 'hace {0} h', other: 'hace {0} h' }
          }
        },
        minute: {
          displayName: 'minuto',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} minuto', other: 'dentro de {0} minutos' },
            past: { one: 'hace {0} minuto', other: 'hace {0} minutos' }
          }
        },
        'minute-short': {
          displayName: 'min',
          relative: { 0: 'este minuto' },
          relativeTime: {
            future: { one: 'dentro de {0} min', other: 'dentro de {0} min' },
            past: { one: 'hace {0} min', other: 'hace {0} min' }
          }
        },
        second: {
          displayName: 'segundo',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} segundo', other: 'dentro de {0} segundos' },
            past: { one: 'hace {0} segundo', other: 'hace {0} segundos' }
          }
        },
        'second-short': {
          displayName: 's',
          relative: { 0: 'ahora' },
          relativeTime: {
            future: { one: 'dentro de {0} s', other: 'dentro de {0} s' },
            past: { one: 'hace {0} s', other: 'hace {0} s' }
          }
        }
      }
    },
    { locale: 'es-UY', parentLocale: 'es-419' },
    { locale: 'es-VE', parentLocale: 'es-419' }
  ];
});
